import React from "react";
import { useMutation } from "react-query";
import { createErrors } from "../../../queries/helpers";
import { useErrorHandler } from "react-error-boundary";
import { Field, Form } from "react-final-form";
import CustomSelect from "../../common/CustomSelect";
import ValidatedInput from "../../common/ValidatedInput";
import { submitQuestion } from "../../../queries/consumer/support";
import { addErrorType, addPriority, addSupportType } from "../../helpers";
import Apps from "../../../config/Apps";
import ErrorCodes from "../../../config/ErrorCodes";
import Priority from "../../../config/Priority";

const SupportPage = ({ toast }) => {
  const supportTypeOptions = Apps.filter((app) => app.enabled);
  supportTypeOptions.push({
    name: "API Documentation",
    label: "API Documentation",
    info: "",
    enabled: "",
  });
  const errorTypeOptions = ErrorCodes;
  const priorityOptions = Priority;
  const handleError = useErrorHandler();
  const newQuestion = useMutation(async (formData) => {
    await submitQuestion(formData);
  });

  const onSubmit = async (values) => {
    let new_values = { ...values };
    new_values = addSupportType(new_values);
    new_values = addErrorType(new_values);
    new_values = addPriority(new_values);
    return await newQuestion
      .mutateAsync(new_values)
      .then(() => {
        toast.success("Your question is send successfully!");
      })
      .catch((error) => {
        toast.error([
          {
            title: "Failed to send your question",
            body: `${error.response.data.errors
              .map((error) => error.detail)
              .join(", ")}`,
          },
        ]);
        return createErrors(error, "Failed to send your question", handleError);
      });
  };

  return (
    <div className="container mw-520">
      <h3>Support</h3>
      <p className="mb-4">
        Have a <strong>technical question</strong>?{" "}
        {
          "Don't worry, send us your questions and we will get back to you as soon as possible."
        }
      </p>
      <p>
        For <i>non-technical</i> questions, please contact us at{" "}
        <a className="link-color" href="#">
          {"info@finclude.ai"}
        </a>
        .
      </p>
      <Form
        onSubmit={onSubmit}
        render={({
          submitError,
          handleSubmit,
          form,
          submitting,
          pristine,
          values,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className="fin-col">
              <label>Support type</label>
              <Field
                name="supportType"
                options={supportTypeOptions}
                component={CustomSelect}
                isSearchable={false}
                isMulti={false}
                isClearable={true}
              />
            </div>
            <div className="fin-col">
              <label>Error type</label>
              <Field
                name="errorType"
                options={errorTypeOptions}
                component={CustomSelect}
                isSearchable={false}
                isMulti={false}
                isClearable={true}
              />
            </div>
            <div className="fin-col">
              <label>Priority</label>
              <Field
                name="priority"
                options={priorityOptions}
                component={CustomSelect}
                isSearchable={false}
                isMulti={false}
                isClearable={true}
              />
            </div>

            <div className="fin-col">
              <label>Subject</label>
              <Field
                inputClassName="fin-control"
                name="subject"
                component={ValidatedInput}
                type="text"
                placeholder="Subject"
              />
            </div>

            <div className="fin-col">
              <label>Your question</label>
              <Field
                className="fin-control"
                name="question"
                component="textarea"
                placeholder="Your question"
              />
            </div>

            <div className="mt-3">
              <button
                disabled={submitting || pristine}
                id="submit"
                className="btn btn-sm btn-main"
              >
                Submit question
              </button>
              <button
                type="button"
                className="btn btn-sm btn-cancel"
                onClick={form.reset}
                disabled={submitting || pristine}
              >
                Reset
              </button>
            </div>
          </form>
        )}
      />
    </div>
  );
};

SupportPage.propTypes = {};

export default SupportPage;
